import { objectSpread2 as _objectSpread2, defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';

var getCssPixelWidth = function getCssPixelWidth(width) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "100%";

  if (typeof width === "number") {
    return "".concat(width, "px");
  } else if (typeof width === "string") {
    return width;
  }

  return defaultValue;
}; // this is very much an approximation for default Cinnamon styling
// and may have to be tweaked!

var CHARACTERS_TO_EMS = 0.75;
var getCssCharacterWidth = function getCssCharacterWidth(width) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "100%";

  if (typeof width === "number") {
    return "".concat(width * CHARACTERS_TO_EMS, "em");
  } else if (typeof width === "string") {
    return width;
  }

  return defaultValue;
};
var parseInlineStyle = function parseInlineStyle(style) {
  if (!style) return {};
  var el = document.createElement("span");
  el.setAttribute("style", style);
  var keys = [];

  for (var i = 0; i < el.style.length; i++) {
    var key = el.style.item(i);
    if (key) keys.push(key);
  }

  return keys.reduce(function (acc, k) {
    var value = el.style.getPropertyValue(k);
    if (!value) return acc;
    return _objectSpread2(_objectSpread2({}, acc), {}, _defineProperty({}, k, value));
  }, {});
};

export { getCssCharacterWidth, getCssPixelWidth, parseInlineStyle };
